<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input
            size="small"
            clearable
            placeholder="作者名称"
            class="!w-200px"
            v-model="formInline.author"
          />
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.royaltiesTypeId" placeholder="稿件类型" clearable>
            <el-option
              v-for="item in royaltiesType"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.royaltiesCategoryId" placeholder="稿件类别" clearable>
            <el-option
              v-for="item in royaltiesCategory"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.royaltiesLevel" placeholder="稿件级别" clearable>
            <el-option
              v-for="item in royaltiesLeavel"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            size="small"
            class="max-w-330px"
            v-model="formInline.timeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="发布时间"
            end-placeholder="发布时间"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          ><el-button size="small" type="primary" @click="searchList">搜索</el-button>
          <el-button
            size="small"
            @click="openUploadDialog"
            :loading="btnLoading"
            >导出</el-button
          ></el-form-item
        >
      </el-form>
    </div>
    <el-table
      height="calc(100% - 106px)"
      :data="tableData"
      @cell-click="cellClick"
      v-loading="tableLoading"
      ref="table"
      border
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column type="index" align="center" label="序号" width="50" />
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :label="item.label"
        :width="item.width"
        :prop="item.prop"
      >
        <template slot-scope="scope">
          <div v-if="scope.column.property === 'publishTime'">
            {{ dayjs(scope.row[scope.column.property]).format('YYYY/MM/DD HH:mm:ss') }}
          </div>
          <div v-else-if="scope.column.property === 'isWithImage'">
            {{ scope.row[scope.column.property] ? '是' : '否' }}
          </div>
          <div v-else>
            {{ scope.row[scope.column.property] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="text-right mt-20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import { RoyaltiesRecordApi } from '@wiz-api/workbench'
import { downLoadExcel } from '@/assets/js/CommonDownload'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const royaltiesRecordApi = new RoyaltiesRecordApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  data() {
    return {
      formInline: {
        author: null,
        royaltiesTypeId: null,
        royaltiesCategoryId: null,
        royaltiesLevel: null,
        timeRange: [],
      },
      royaltiesCategory: [],
      royaltiesType: [],
      royaltiesLeavel: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      tableData: [],
      tableLoading: false,
      columnList: [
        {
          label: '作者名称',
          prop: 'author',
          width: '',
        },
        {
          label: '部门',
          prop: 'deptName',
          width: '',
        },
        {
          label: '稿件标题',
          prop: 'title',
          width: '',
        },
        {
          label: '栏目名称',
          prop: 'columnName',
          width: '',
        },
        {
          label: '发布时间',
          prop: 'publishTime',
          width: '',
        },
        {
          label: '稿件类型',
          prop: 'royaltiesType',
          width: '',
        },
        {
          label: '稿件类别',
          prop: 'royaltiesCategory',
          width: '',
        },
        {
          label: '稿件级别',
          prop: 'royaltiesLevel',
          width: '',
        },
        {
          label: '是否配照片',
          prop: 'isWithImage',
          width: '',
        },
        {
          label: '分配稿费',
          prop: 'royaltiesCount',
          width: '',
        },
      ],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      btnLoading: false,
      selection: [],
    }
  },
  mounted() {
    this.dataCategoryApi()
    this.searchList()
  },
  methods: {
    selectionChange(selection) {
      this.selection = selection
    },
    async dataCategoryApi() {
      const param = {
        code: 'RoyaltiesCategory',
        includeDetails: true,
      }
      const [err, res] = await dataCategoryApi.getByCode(param)
      if (!err && res) {
        this.royaltiesCategory = res.dataItems
      }

      const params = {
        code: 'RoyaltiesType',
        includeDetails: true,
      }
      const [errType, resType] = await dataCategoryApi.getByCode(params)
      if (!errType && resType) {
        this.royaltiesType = resType.dataItems
      }

      const paramresLeavel = {
        code: 'RoyaltiesLevel',
        includeDetails: true,
      }
      const [errLeavel, resLeavel] = await dataCategoryApi.getByCode(paramresLeavel)
      if (!errLeavel && resLeavel) {
        this.royaltiesLeavel = resLeavel.dataItems
      }
    },
    async searchList() {
      this.tableLoading = true
      const [err, res] = await royaltiesRecordApi.getRoyaltiesPersonList(
        this.page.pageNo,
        this.page.pageSize,
        {
          author: this.formInline.author,
          royaltiesCategoryId: this.formInline.royaltiesCategoryId,
          royaltiesTypeId: this.formInline.royaltiesTypeId,
          royaltiesLevel: this.formInline.royaltiesLevel,
          startTime: this.formInline.timeRange ? this.formInline.timeRange[0] ?? null : null,
          endTime: this.formInline.timeRange ? this.formInline.timeRange[1] ?? null : null,
        }
      )
      if (!err && res) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
      this.tableLoading = false
    },
    cellClick() {},
    async openUploadDialog() {
      this.btnLoading = true
      const [err, res] = await royaltiesRecordApi.royaltiesPersonListExport({
        body: {
          pageNo: 1,
          pageSize: 9999,
          title: this.formInline.title,
          royaltiesCategoryId: this.formInline.royaltiesCategoryId,
          royaltiesTypeId: this.formInline.royaltiesTypeId,
          royaltiesLevel: this.formInline.royaltiesLevel,
          startTime: this.formInline.timeRange ? this.formInline.timeRange[0] ?? null : null,
          endTime: this.formInline.timeRange ? this.formInline.timeRange[1] ?? null : null,
          ids: _.map(this.selection, (item) => {
            return item.id
          }),
        },
        returnType: 'Blob',
      })
      if (!err && res) {
        this.btnLoading = false
        downLoadExcel('人员稿费清单导出', res)
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.searchList()
    },
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.searchList()
    },
  },
}
</script>

<style lang="scss" scoped></style>
